import { Component, OnInit } from '@angular/core';
import { HttpResponseBase } from '@angular/common/http';
import { AlertService } from 'src/app/shared/services/alert.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { UrlService } from 'src/app/shared/services/url.service';
import { GlobalService } from 'src/app/shared/global.service';
import { valorModel } from 'src/app/models/valor-model';
import { DependenciaModel } from 'src/app/models/dependencia.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { UtilService } from 'src/app/shared/services/util.service';

@Component({
    selector: 'app-reporte-informe-total-ingresos',
    templateUrl: './reporte-informe-total-ingresos.component.html',
    styleUrls: ['./../generar-reporte.component.scss']
})
export class ReporteInformeTotalIngresosComponent implements OnInit {

    public dependencia: DependenciaModel[];
    public tipoFuncionario: valorModel[];
    public sede: string;
    public validar = true;
    public datosArchivo: any;
    public filtroFechaInicio: string;
    public filtroFechaFin: string;
    public consolidadoDetalle: string;
    public filtroDocumento: string;
    public filtroConsolidadoDetalle: string;
    public filtroTipoFuncionario: string;
    public filtroDependencia: string;
    public filtroSede: string;
    public placeholderDate: string;

    constructor(
        private global: GlobalService,
        private urlService: UrlService,
        private spinner: NgxSpinnerService,
        private alertService: AlertService,
        private utilService: UtilService
    ) { }
    ngOnInit() {
        this.placeholderDate = ConstantesService.SELECCION_FECHA;
        this.obtenerCantidadRegistros();
        this.consultarTipoFuncionario();
        this.getDependencias();
        this.obtenerSede();
    }

    /**
     * Método que vuelve todos los filtros undefined solamente si el tipo de Usuario a cambiado
     */
    borrarDatos() {
        this.filtroDocumento = undefined;
        this.filtroTipoFuncionario = undefined;
        this.filtroDependencia = undefined;
        this.filtroSede = undefined;
        this.filtroFechaFin = undefined;
        this.filtroFechaInicio = undefined;
    }

    /**
     * Método que valida los campos Obligatorios para el cual habilitar el botón 'Generar Reporte'
     * y valida algunos filtro undefined
     */
    validacion() {
        if (!this.utilService.validarCamposObligatorios(this.filtroConsolidadoDetalle)
            // || this.filtroConsolidadoDetalle === 'undefined'
            ) {
            this.validar = true;
        } else if (!this.utilService.validarCamposObligatorios(this.filtroFechaInicio)
            // || this.filtroFechaInicio === 'undefined'
            ) {
            this.validar = true;
        } else if (!this.utilService.validarCamposObligatorios(this.filtroFechaFin)
            // || this.filtroFechaFin === 'undefined'
            ) {
            this.validar = true;
        } else {
            this.validar = false;
        }
        if (!this.utilService.validarCamposObligatorios(this.filtroTipoFuncionario)) {
            this.filtroTipoFuncionario = undefined;
        }
        if (!this.utilService.validarCamposObligatorios(this.filtroDependencia)) {
            this.filtroDependencia = undefined;
        }
        if (!this.utilService.validarCamposObligatorios(this.filtroSede)) {
            this.filtroSede = undefined;
        }
    }

    /**
     * Método que Consulta los dominios que se relacionen con el nombre 'ConsolidadoDetalle'
     */
    public obtenerCantidadRegistros() {
        this.spinner.show();
        const serviceProvider = 'ObtenerDominio';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy=detalleDominioPK.nombreDominio', 'ConsolidadoDetalle']);
        const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);
        this.global.getGenerico(url).subscribe(
            data => {
                this.consolidadoDetalle = data;
                this.spinner.hide();
            }, err => {
                this.cathException('No es posible Obtener El consolidado y Detallado');
            }
        );
    }

    /**
     * Método que consulta los tipo de Funcionarios existentes
     */
    public consultarTipoFuncionario() {
        const serviceProvider = 'ObtenerTipoFuncionario';
        const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_ACCVIS);
        this.global.postGenerico(url).subscribe(
            data => {
                this.tipoFuncionario = data;
            }, err => {
                this.cathException('No es posible Cargar los tipos de Funcionario');
            }
        );
    }

    /**
     * Consulta el tipo de Dependencias Existentes
     */
    getDependencias() {
        this.spinner.show();
        const serviceProvider = 'ObtenerDependencias';
        const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_ACCVIS);
        this.global.getGenerico(url).subscribe(
            data => {
                this.dependencia = data;
                this.spinner.hide();
            }, err => {
                this.cathException('No es posible Cargar las Dependencias');
            }
        );
    }

    /**
     * Consulta los tipo de Sedes Existente
     */
    public obtenerSede() {
        this.spinner.show();
        const serviceProvider = 'ObtenerDominio';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy=detalleDominioPK.nombreDominio', 'Sede']);
        const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);
        this.global.getGenerico(url).subscribe(
            data => {
                this.sede = data;
                this.spinner.hide();
            }, err => {
                this.cathException('No es posible Obtener las Sedes');
            }
        );
    }

    // /**
    //  * Método que valida la fecha Inicial y la anexa a una variable especifica filtroFechaInicio
    //  * @param event resive la fecha seleccionada por el usuario
    //  */
    // public handlerDatePickeRInicio(event) {
    //     this.filtroFechaInicio = this.utilService.convertirFechaConcatenada(event);
    // }

    // /**
    //  * Método que valida la fecha Final y la anexa a una variable especifica filtroFechaFin
    //  * @param event resive la fecha seleccionada por el usuario
    //  */
    // public handlerDatePickeRFin(event) {
    //     this.filtroFechaFin = this.utilService.convertirFechaConcatenada(event);
    // }

    /**
     * Método que recolecta los filtros y realiza el llamado del servicio correspondiente
     * al BACKEND y obtiene el resultado de la consulta deseada
     */
    GenerarReporteTotalIngresos() {
        this.validacion();
        if (!this.validar) {
            this.spinner.show();
            if (this.filtroDocumento && this.filtroDocumento.length > 0 && !/^([A-Z0-9])*$/.test(this.filtroDocumento)) {
                this.cathException('Por favor ingrese nuevamente un “Número de Documento”');
                this.cathException('La información ingresada en “Número de Documento”'
                    + 'no corresponde con lo solicitado, por favor verifique');
                document.getElementById('numeroDocumento').focus();
                return;
            }
            if (this.filtroFechaInicio > this.filtroFechaFin){
                this.cathException('La fecha inicio debe ser menor que la fecha fin');
                return;
            }
            const filtros = {
                filtroConsolidadoDetalle: this.filtroConsolidadoDetalle,
                filtroDocumento: this.filtroDocumento,
                filtroTipoFuncionario: this.filtroTipoFuncionario,
                filtroDependencia: this.filtroDependencia,
                filtroSede: this.filtroSede,
                filtroFechaInicio: this.filtroFechaInicio,
                filtroFechaFin: this.filtroFechaFin
            };
            const serviceProvider = 'reporteTotalIngresos';
            const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_ACCVIS);
            this.global.postGenerico(url, filtros).subscribe(
                data => {
                    this.datosArchivo = data;
                    this.spinner.hide();
                    this.alertService.generateAlertSuccess('Su reporte se está descargando', '');
                    this.descargarArchivo();
                }, err => {
                    if (err.status === 500) {
                        this.cathException(err.error.message);
                    } else {
                        this.cathException('El reporte no se ha podido generar');
                    }
                }
            );
        }
    }



    /**
     * Método que convierte el archivo Excel y realiza la descarga del mismo
     */
    descargarArchivo() {
        ConstantesService.descargarDocumento('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            , this.datosArchivo.nombre, this.datosArchivo.archivo);
        this.spinner.hide();
    }

    /**
     * Método de control de Excepciones
     * @param error                 mensaje saliente respecto al error ocurrido
     * @param err: HttpResponseBase Tipo de error
     */
    cathException(error) {
        this.alertService.generateAlertError(error, 'Error');
        this.spinner.hide();
    }
}
